<template>
  <div class="drawer">
    <div class="drawer-container">
      <el-tabs v-model="activeName" @tab-click="handleClickTab">
        <el-tab-pane :label="$t('text.baseInfo')" name="detail">
          <div class="drawer-content with-tab">
            <el-form
              class="box"
              ref="materialForm"
              :model="material"
              label-width="80px"
            >
              <fieldset class="mgb15">
                <el-row>
                  <el-col :span="8">
                    <el-form-item :label="$t('material.serialNo')">
                      {{ material.serialNo }}
                    </el-form-item>
                  </el-col>
                  <el-col :span="8">
                    <el-form-item :label="$t('material.name')">{{
                      material.name
                    }}</el-form-item>
                  </el-col>

                  <el-col :span="8">
                    <el-form-item :label="$t('menu.subjects')">{{
                      material.subjectName
                    }}</el-form-item>
                  </el-col>
                </el-row>
                <el-row>
                  <el-col :span="8">
                    <el-form-item :label="$t('material.color')">{{
                      material.color
                    }}</el-form-item>
                  </el-col>
                  <el-col :span="8">
                    <el-form-item :label="$t('material.colorNo')">{{
                      material.colorNo
                    }}</el-form-item>
                  </el-col>
                  <el-col :span="8">
                    <el-form-item :label="$t('material.handCycle')"
                      >{{ material.minHandCycle }} -
                      {{ material.maxHandCycle }}</el-form-item
                    >
                  </el-col>
                </el-row>
                <el-row>
                  <el-col :span="8">
                    <el-form-item :label="$t('material.inUnit')">{{
                      material.inUnit
                    }}</el-form-item>
                  </el-col>
                  <el-col :span="8">
                    <el-form-item :label="$t('material.outUnit')">{{
                      material.unit
                    }}</el-form-item>
                  </el-col>
                  <el-col :span="8">
                    <el-form-item :label="$t('material.exchange')">{{
                      material.exchange
                    }}</el-form-item>
                  </el-col>
                </el-row>
                <el-row>
                  <el-col :span="8">
                    <el-form-item :label="$t('material.inPrice')">{{
                      material.inPrice | currency4
                    }}</el-form-item>
                  </el-col>
                  <el-col :span="8">
                    <el-form-item :label="$t('material.outPrice')">{{
                      material.price | currency4
                    }}</el-form-item>
                  </el-col>
                </el-row>
              </fieldset>
              <fieldset class="mgb15">
                <legend>{{ $t("text.remark") }}</legend>
                <raw-html :content="material.remark" type="richText" />
              </fieldset>
            </el-form>
          </div>
        </el-tab-pane>
        <el-tab-pane :label="$t('menu.suppliers')" name="supplier">
          <div
            class="drawer-content"
            :class="
              Permit.canActions('mmsMaterialManage') ? 'with-tab-footer' : ''
            "
          >
            <fieldset class="mgb15">
              <vxe-table
                :data="material.materialSuppliers"
                id="materialSuppliersTable"
                row-id="id"
                ref="recordsTable"
                class="recordsTable"
                size="mini"
                resizable
                round
                highlight-hover-row
                auto-resize
                border
                :scroll-y="{ enabled: false }"
              >
                <vxe-table-column
                  field="supplierName"
                  :title="$t('menu.suppliers')"
                  min-width="200"
                />

                <vxe-table-column
                  field="supplierMaterialNo"
                  :title="$t('material.supplierSerialNo')"
                  min-width="200"
                />
                <vxe-table-column
                  field="price"
                  :title="$t('product.supplierPrice')"
                  min-width="90"
                >
                  <template v-slot="{ row }">
                    <span v-if="row.price != null">
                      {{ row.price | currency4 }}
                    </span>
                  </template>
                </vxe-table-column>
                <vxe-table-column
                  field="defaultSupplier"
                  :title="$t('product.defaultSupplier')"
                  min-width="90"
                >
                  <template v-slot="{ row }">{{
                    $t("boolean." + row.defaultSupplier)
                  }}</template>
                </vxe-table-column>
                <vxe-table-column
                  v-if="Permit.canActions('mmsMaterialManage')"
                  field="action"
                  :title="$t('text.action')"
                  width="180"
                >
                  <template v-slot="{ row }">
                    <el-button
                      type="text"
                      size="mini"
                      @click="editMaterialSupplier(row)"
                      >{{ $t("text.edit") }}</el-button
                    >
                    <el-button
                      type="text"
                      size="mini"
                      @click="deleteMaterialSupplier(row)"
                      >{{ $t("text.delete") }}</el-button
                    >
                    <el-button
                      v-if="!row.defaultSupplier"
                      type="text"
                      size="mini"
                      @click="setDefaultSupplier(row)"
                      >{{ $t("action.setDefaultSupplier") }}</el-button
                    >
                  </template>
                </vxe-table-column>
              </vxe-table>
            </fieldset>
          </div>
        </el-tab-pane>
      </el-tabs>
    </div>
    <div class="drawer-footer">
      <el-button
        v-if="
          activeName == 'supplier' && Permit.canActions('mmsMaterialManage')
        "
        type="success"
        size="small"
        @click="addSupplier"
      >
        + {{ $t("menu.suppliers") }}
      </el-button>
    </div>

    <!-- 编辑供应商报价 -->
    <el-dialog
      :append-to-body="true"
      :title="$t('rules.edit', [$t('product.supplierPrice')])"
      :visible.sync="editMaterialSupplierDF"
      :close-on-click-modal="false"
      width="30%"
    >
      <el-form
        ref="editMaterialSupplierObjForm"
        :model="editMaterialSupplierObj"
        label-width="96px"
      >
        <el-form-item
          :prop="'price'"
          :label="$t('product.supplierPrice')"
          :rules="[
            {
              required: true,
              message: $t('rules.required', [$t('product.supplierPrice')]),
              trigger: 'blur',
            },
          ]"
        >
          <el-input size="small" v-model.trim="editMaterialSupplierObj.price" />
        </el-form-item>
        <el-form-item
          :prop="'supplierMaterialNo'"
          :label="$t('material.supplierSerialNo')"
        >
          <!-- <el-input
            size="small"
            v-model.trim="editMaterialSupplierObj.supplierMaterialNo"
          /> -->
          <el-autocomplete
            size="small"
            v-model="editMaterialSupplierObj.supplierMaterialNo"
            style="width: 100%"
            :placeholder="
              $t('rules.mustFill', [$t('material.supplierSerialNo')])
            "
            :fetch-suggestions="querySearchSerialNo"
            @select="handleSelectSerialNo(index)"
          >
            <template slot-scope="{ item }">
              <div class="name">{{ item.serialNo }}</div>
              <span class="addr">
                {{ item.name }}-{{ item.color }}
                <div class="addr">
                  {{ item.suppliersNoStr }}
                </div>
              </span>
            </template>
          </el-autocomplete>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button
          type="primary"
          plain
          :loading="editMaterialSupplierSubmitDoing"
          size="small"
          @click="editProductSupplierSubmit"
          >{{ $t("text.submit") }}</el-button
        >
        <el-button size="small" @click="editMaterialSupplierDF = false">{{
          $t("text.close")
        }}</el-button>
      </div>
    </el-dialog>
    <!-- 新增产品供应商 -->
    <el-dialog
      :append-to-body="true"
      :title="$t('rules.create', [$t('product.supplierPrice')])"
      :close-on-click-modal="false"
      :visible.sync="addProductSupplierDF"
      width="50%"
    >
      <el-form ref="addSupplierForm" :model="addSupplierObj">
        <div v-for="(item, index) in addSupplierObj.items" :key="index">
          <el-row :gutter="10">
            <el-col :span="6">
              <el-form-item>
                <el-select
                  size="small"
                  v-model="item.supplierId"
                  clearable
                  filterable
                  :placeholder="
                    $t('rules.mustFillSimple', [$t('menu.suppliers')])
                  "
                  @change="existJudgeProductSupplier(index)"
                >
                  <el-option
                    v-for="supplier in addMaterialSupplierSuppliers"
                    :key="supplier.id"
                    :label="supplier.name"
                    :value="supplier.id"
                  />
                </el-select>
                <small
                  v-if="item._localRepeat || item._invRepeat"
                  class="red"
                  >{{ $t("rules.filledIn", ["供应商和料号"]) }}</small
                >
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item>
                <el-input
                  size="small"
                  v-model.trim="item.price"
                  :placeholder="$t('product.supplierPrice')"
                />
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item>
                <!-- <el-input
                  size="small"
                  v-model.trim="item.supplierMaterialNo"
                  :placeholder="$t('material.supplierSerialNo')"
                /> -->
                <el-autocomplete
                  size="small"
                  v-model="item.supplierMaterialNo"
                  style="width: 100%"
                  :placeholder="
                    $t('rules.mustFill', [$t('material.supplierSerialNo')])
                  "
                  :fetch-suggestions="querySearchSerialNo"
                  @select="handleSelectSerialNo(index)"
                  @blur="existJudgeProductSupplier(index)"
                >
                  <template slot-scope="{ item }">
                    <div class="name">{{ item.serialNo }}</div>
                    <span class="addr">
                      {{ item.name }}-{{ item.color }}
                      <div class="addr">
                        {{ item.suppliersNoStr }}
                      </div>
                    </span>
                  </template>
                </el-autocomplete>
              </el-form-item>
            </el-col>
            <el-col :span="1">
              <el-form-item>
                <i
                  v-if="index"
                  class="el-icon-delete red"
                  @click="removeSupplier(index)"
                />
              </el-form-item>
            </el-col>
          </el-row>
        </div>
        <div>
          <el-row :gutter="20">
            <el-col :span="20">
              <el-button
                type="success"
                plain
                icon="el-icon-plus"
                size="mini"
                @click="addMoreSupplier"
                >{{ $t("text.create") }}</el-button
              >
            </el-col>
          </el-row>
        </div>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button
          type="primary"
          plain
          :loading="addSupplierSubmitDoing"
          size="small"
          @click="addSupplierSubmit"
          >{{ $t("text.submit") }}</el-button
        >
        <el-button size="small" @click="addProductSupplierDF = false">{{
          $t("text.close")
        }}</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import Vue from "vue";
import { page } from "@/utils/mixins.js";
import RawHtml from "@/components/RawHtml";
import Material from "@/api/material.js";
import SupplierMms from "@/api/supplierMms.js";

function buildMaterialSupplier() {
  return {
    supplierId: null,
    price: null,
    defaultSupplier: false,
    supplierMaterialNo: null,
    materialId: null,
    _localRepeat: false,
    _invRepeat: false,
  };
}

export default {
  props: {
    id: Number,
  },
  mixins: [page],
  components: {
    RawHtml,
  },
  data() {
    return {
      activeName: "detail",
      material: { uuid: null },
      materialSuppliers: [],
      materials: [],

      // 编辑供应商
      editMaterialSupplierDF: false,
      row: null,
      editMaterialSupplierObj: {
        price: null,
        supplierMaterialNo: null,
      },
      editMaterialSupplierSubmitDoing: false,
      // 新增供应商
      addProductSupplierDF: false,
      suppliers: [],
      addMaterialSupplierSuppliers: [],
      addSupplierObj: {
        items: [],
      },
      addSupplierSubmitDoing: false,
    };
  },
  created() {
    const self = this;
    self.handleClickTab();
  },
  methods: {
    handleClickTab(tab, event) {
      if (this.activeName == "detail") {
        this.getMaterial();
      }
      if (this.activeName == "supplier") {
        // this.getMaterialSuppliers();
      }
    },

    getMaterial() {
      const self = this;
      self.loadingStart();
      Material.findById(self.id).then(function (res) {
        if (res.data.code === 200) {
          self.material = res.data.entity;
        } else {
          self.sysError();
        }
        self.loadingEnd();
      });
    },
    getMaterialSuppliers() {
      const self = this;
      Material.materialSuppliersfindById(self.id).then(function (res) {
        if (res.status === 200) {
          self.materialSuppliers = res.data;
        } else {
          self.sysError();
        }
      });
    },
    // getSuppliers() {
    //   const self = this;
    //   SupplierMms.findByTenantId().then(function (res) {
    //     if (res.status === 200) {
    //       self.suppliers = res.data;
    //     } else {
    //       self.sysError();
    //     }
    //   });
    // },
    // 新增产品供应商
    addSupplier() {
      const self = this;
      self.addSupplierSubmitDoing = false;
      SupplierMms.findByTenantId().then(function (res) {
        if (res.status === 200) {
          self.suppliers = res.data;
          // const materialSupplierIds = self.material.materialSuppliers.map(
          //   (s) => s.supplierId
          // );
          self.addMaterialSupplierSuppliers = self.suppliers;
          // .filter(
          //   (s) => !materialSupplierIds.includes(s.id)
          // );
          self.addSupplierObj.items = [
            buildMaterialSupplier(),
            buildMaterialSupplier(),
            buildMaterialSupplier(),
          ];
          self.addProductSupplierDF = true;
        } else {
          self.sysError();
        }
      });
    },
    removeSupplier(index) {
      this.addSupplierObj.items.splice(index, 1);
    },
    addMoreSupplier() {
      this.addSupplierObj.items.push(buildMaterialSupplier());
    },
    existJudgeProductSupplier(idx) {
      const self = this;
      this.addSupplierObj.items[idx]._localRepeat = false;
      this.addSupplierObj.items[idx]._invRepeat = false;
      if (
        this.addSupplierObj.items[idx].supplierId != null &&
        (this.addSupplierObj.items[idx].supplierMaterialNo ?? "") != ""
      ) {
        // 本地过滤
        const iis = self.addSupplierObj.items.filter(function (s) {
          return (
            s.supplierId === self.addSupplierObj.items[idx].supplierId &&
            s.supplierMaterialNo ===
              self.addSupplierObj.items[idx].supplierMaterialNo
          );
        });
        if (iis.length > 1) {
          this.addSupplierObj.items[idx]._localRepeat = true;
        }

        // 本地过滤===
        const invIis = self.material.materialSuppliers.filter(function (s) {
          return (
            s.supplierId === self.addSupplierObj.items[idx].supplierId &&
            s.supplierMaterialNo ===
              self.addSupplierObj.items[idx].supplierMaterialNo
          );
        });
        if (invIis.length > 0) {
          this.addSupplierObj.items[idx]._invRepeat = true;
        }
      }
    },
    querySearchSerialNo(queryString, cb) {
      const self = this;
      if (queryString == null || queryString.length < 1) {
        return;
      }
      Material.vagueFindBySerialNoOrName({ serialNo: queryString }).then(
        function (res) {
          self.materials = res.data;
          if (self.materials.length !== 0) {
            for (const material of self.materials) {
              Vue.set(material, "value", material.serialNo);
            }
          }
          cb(self.materials);
        }
      );
    },
    handleSelectSerialNo(idx) {
      const self = this;
      const item = self.materials.find(
        (p) => p.serialNo === self.addSupplierObj.items[idx].materialSerialNo
      );
    },
    addSupplierSubmit() {
      const self = this;
      const items = this.addSupplierObj.items.filter(function (item) {
        return item.supplierId != null;
      });
      if (items.length === 0) {
        self.$message({
          message: self.$t("prompt.atLeastOneValidDataFillIn"),
          type: "warning",
        });
        return;
      }
      const errDatas = items.filter(
        (s) => s._localRepeat === true || s._invRepeat === true
      );
      if (errDatas.length !== 0) {
        self.$message({
          message: this.$t("prompt.errorMessage"),
          type: "warning",
        });
        return;
      }
      for (const i of items) {
        i.materialId = self.id;
      }
      if (self.material.materialSuppliers.length === 0) {
        items[0].defaultSupplier = true;
      }
      self.addSupplierSubmitDoing = true;
      // console.log("====", items);
      Material.createMaterialSupplier(items).then(function (res) {
        self.addSupplierSubmitDoing = false;
        self.addProductSupplierDF = false;
        if (res.status === 200) {
          self.$message({
            message: self.$t("prompt.addSuccess"),
            type: "success",
          });
          self.getMaterial();
          self.$emit("updateInfo");
        } else {
          self.sysError();
        }
      });
    },

    // 设置默认供应商
    setDefaultSupplier(row) {
      const self = this;
      Material.updateDefaultSupplier(self.id, row.id).then(function (res) {
        if (res.status === 200) {
          self.$message({
            message: self.$t("prompt.setSuccess"),
            type: "success",
          });
          self.getMaterial();
          self.$emit("updateInfo");
        } else {
          self.sysError();
        }
      });
    },
    // 删除产品供应商
    deleteMaterialSupplier(row) {
      const self = this;
      if (confirm(this.$t("prompt.confirmDelete"))) {
        Material.deleteMaterialSupplier(row.id).then(function (res) {
          if (res.status === 200) {
            self.$message({
              message: self.$t("prompt.delSuccess"),
              type: "success",
            });
            self.getMaterial();
            self.$emit("updateInfo");
          } else {
            self.sysError();
          }
        });
      }
    },
    // 编辑产品供应商
    editMaterialSupplier(row) {
      const self = this;
      self.row = row;
      self.editMaterialSupplierObj.price = row.price;
      self.editMaterialSupplierObj.supplierMaterialNo = row.supplierMaterialNo;
      self.editMaterialSupplierSubmitDoing = false;
      self.editMaterialSupplierDF = true;
    },
    editProductSupplierSubmit() {
      const self = this;
      this.$refs.editMaterialSupplierObjForm.validate((valid) => {
        if (valid) {
          self.editMaterialSupplierSubmitDoing = true;
          Material.updateMaterialSupplier(
            self.row.id,
            self.editMaterialSupplierObj
          ).then(function (res) {
            self.editMaterialSupplierSubmitDoing = false;
            self.editMaterialSupplierDF = false;
            if (res.status === 200) {
              self.$message({
                message: self.$t("prompt.editSuccess"),
                type: "success",
              });
              self.getMaterial();
              self.$emit("updateInfo");
            } else {
              self.sysError();
            }
          });
        } else {
          return false;
        }
      });
    },
  },
};
</script>